import { BaseService } from '../../infra/base.service'
import type { Business } from './business.entity'
import type { BusinessRepository } from './business.repository'

export class BusinessService extends BaseService<Business> {
    constructor(private rep: BusinessRepository) {
        super(rep)
    }
}
